import React from 'react';
import styled from 'styled-components';
import { colors } from 'Constants';

import { Container } from 'Components/core';

const Tab = styled.div`

font-family: "Elevance Sans Semibold";
font-weight: 600;
font-size: 24px;
//line-height: 36px;
text-align: center;





display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  position: relative;
  width: 100%;
 padding:5px;
 padding-top:10px;
 padding-bottom:10px;
 
  
 color: ${props => (props.active ? '#131331' : '#1355e9')};
   
  cursor: pointer;
  font-size: 1.0em;
  user-select: none;
  
  border-bottom: 3px solid ${props => (props.active ? '#131331' : '#EEEEEE')};
 
`;

export default props => [
  <Tab onClick={props.onClick} onKeyDown={(e)=>{
    if(e.key === 'Enter'){
      props.onClick();
    } 
  }} tabIndex={0} active={props.active}>
  
    <span dangerouslySetInnerHTML={{ __html: props.header }}></span>
  </Tab>
];
